import ScheduleIntervalDto from "dto/settings/ScheduleIntervalDto";

export default class ScheduleIntervalComparer {
  static areEqual = (x: ScheduleIntervalDto, y: ScheduleIntervalDto) =>
    x.dayOfWeek === y.dayOfWeek &&
    x.start.equals(y.start) &&
    x.end.equals(y.end) &&
    x.scheduleTypeId === y.scheduleTypeId;
}